module.exports = __webpack_public_path__ + "assets/img/29-m.20fb899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/29-m.jpg
// module id = +oTf
// module chunks = 0